import { Category, makeShallowDefinition } from "./Category";
import { Enum } from "./Enum";
import { Grant } from "./Grant";
import { SearchableEnumPresent } from "./PropertyMap";

export namespace AppRoles {

    export type AppRoleDescription<R extends Enum> = Category<R> & {
        grants: SearchableEnumPresent<typeof Grant>
    }

    // Will enforce the shape while allowing keys and values to slip through
    function enforceType<T extends {
        [K in keyof T]: Omit<AppRoleDescription<T[K]>, 'id'>
    }>(val: T) {
        return val
    }

    export const { Flat, FlatList, FlatEnum, FlatEnumList } = makeShallowDefinition(enforceType({
        ADMIN: {
            name: 'Admin',
            description: 'Administrere selskaper og roller',
            grants: {
                map: {
                    [Grant.EDIT_ROLE]: true,
                    [Grant.CREATE_ROLE]: true,
                }
            }
        },
        DEVELOPER: {
            name: 'Utvikler',
            description: 'Utvikler av appen',
            grants: {
                map: {
                    [Grant.EDIT_ROLE]: true,
                    [Grant.CREATE_ROLE]: true,
                }
            }
        },
    }))

    export type AppRoles = typeof FlatEnum
    export type AppRole = keyof typeof FlatEnum
}
